export default "__VITE_ASSET__BZckV_fN__"